"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var vue_router_1 = __importDefault(require("vue-router"));
var utils_1 = require("./utils");
var config_1 = require("./config");
exports["default"] = (function (routerOptions, additionalCacheList) {
    var _a;
    if (additionalCacheList === void 0) { additionalCacheList = []; }
    var cacheUrls = __spreadArray(__spreadArray([], config_1.defaultCacheUrls, true), additionalCacheList, true);
    var currentUrl = window.location.href;
    var cache = (0, utils_1.getCache)(currentUrl, cacheUrls);
    if (!cache)
        return new vue_router_1["default"](routerOptions);
    var router = new vue_router_1["default"](__assign(__assign({}, routerOptions), { mode: 'abstract' }));
    var realUrl = (_a = cache.getRealUrl) === null || _a === void 0 ? void 0 : _a.call(cache, currentUrl);
    if (realUrl) {
        var realFullPath = (0, utils_1.getFullPath)(realUrl, routerOptions.base);
        router.replace(realFullPath);
    }
    return router;
});
//# sourceMappingURL=get-router-3.js.map